import { isDesktop } from '@trello/browser';

import { useHasEligibleWorkspaces } from './runtimeEligibilityChecks/useHasEligibleWorkspaces';
import { useIsCrossFlowMemberConfirmed } from './runtimeEligibilityChecks/useIsCrossFlowMemberConfirmed';

export const useExperimentalPropsForBoardsHomeSidebarPlacement = ({
  workspaceId,
}: {
  workspaceId: string;
}) => {
  // 1. Check that the member is confirmed
  const { isEligible: isMemberConfirmed } = useIsCrossFlowMemberConfirmed();

  // 2. Check that the member has eligible workspaces
  const { isEligible: hasEligibleWorkspaces, eligibleWorkspaceOptions } =
    useHasEligibleWorkspaces({
      workspaceId,
      entitlementRequired: 'standardOrPremium',
      treatFreeTrialAsFree: true,
    });

  // 3. Check that the user is not on desktop
  const isWeb = !isDesktop();

  return {
    isMemberConfirmed,
    hasEligibleWorkspaces,
    eligibleWorkspaceOptions,
    isWeb,
  };
};
